// extracted by mini-css-extract-plugin
export default {"centered":"heading_centered__loWQe"};